import React from 'react';
import { Lightbulb } from 'lucide-react';
import { Card } from '../ui/Card';
import { AppState, ModuleId } from '../../types';
import { GroupId } from '../../config/systemConfig';
import { MODULES } from '../../data/questionLoader';
import { getWeeklyActivityForLearner, getAllModuleTrends } from '../../utils/activityHelpers';
interface ParentTipsProps {
  childName: string;
  learnerData: AppState;
  selectedGroup: GroupId;
  getModuleMastery: (moduleId: ModuleId) => number;
}
export function ParentTips({
  childName,
  learnerData,
  selectedGroup,
  getModuleMastery
}: ParentTipsProps) {
  const moduleMastery = MODULES.map(module => ({
    module,
    mastery: getModuleMastery(module.id)
  })).sort((a, b) => b.mastery - a.mastery);
  const bestModule = moduleMastery[0];
  const weakestModule = moduleMastery[moduleMastery.length - 1];
  const weeklyActivity = getWeeklyActivityForLearner(learnerData.questionStates || {});
  const practiceDays = weeklyActivity.filter(d => d.practiced).length;
  const trends = getAllModuleTrends(learnerData.familyMastery || {}, selectedGroup);
  const tips = [];
  // Tip 1: Based on weekly activity
  if (practiceDays === 0) {
    tips.push(`${childName} heeft deze week nog niet geoefend. Een kort oefenmoment van 10 minuten helpt enorm!`);
  } else if (practiceDays >= 3) {
    tips.push(`Geweldig! ${childName} heeft al ${practiceDays} dagen geoefend deze week. Consistentie is de sleutel tot succes.`);
  } else {
    tips.push(`${childName} is goed op weg deze week. Probeer nog een extra oefenmoment in te plannen.`);
  }
  // Tip 2: Based on trends or mastery
  const improvingModule = MODULES.find(m => trends[m.id] === 'up');
  if (improvingModule) {
    tips.push(`${childName}'s beheersing in ${improvingModule.title} is deze week gestegen! 🎉 Geef een complimentje.`);
  } else if (bestModule.mastery >= 80) {
    tips.push(`${childName} is super goed bezig met ${bestModule.module.title}.`);
  }
  // Tip 3: Based on weak areas
  if (weakestModule.mastery < 30 && bestModule.mastery > 0) {
    tips.push(`Tip: Moedig ${childName} aan om ook eens ${weakestModule.module.title} te oefenen.`);
  }
  return <Card className="p-6 border-amber-200 bg-amber-50/50" data-id="element-4359">
      <div className="flex items-center gap-3 mb-4" data-id="element-4360">
        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-600" data-id="element-4361">
          <Lightbulb className="w-5 h-5" data-id="element-4362" />
        </div>
        <h3 className="font-bold text-amber-900" data-id="element-4363">Tips voor jou</h3>
      </div>

      <ul className="space-y-3" data-id="element-4364">
        {tips.map((tip, index) => <li key={index} className="flex items-start gap-2 text-sm text-amber-800" data-id="element-4365">
            <span className="text-amber-500 mt-0.5" data-id="element-4366">•</span>
            {tip}
          </li>)}
      </ul>
    </Card>;
}